import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";

const initialFValues = {
  remark: "",
  locationId: 0,
  sku: "",
  quantity: 0,
  sku: "",
};

export default function InventoryCorrection(props) {
  const {
    addOrEdit,
    addCorrection,
    recordForEdit,
    products,
    locations,
    setOpenPopup,
  } = props;
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("quantity" in fieldValues)
      temp.quantity = fieldValues.quantity > 0 ? "" : "This field is required.";
    if ("remark" in fieldValues)
      temp.remark = fieldValues.remark ? "" : "Add a remark";
    if ("sku" in fieldValues)
      temp.sku = fieldValues.sku ? "" : "This sku is required.";
    if ("locationId" in fieldValues)
      temp.locationId =
        fieldValues.locationId > 0 ? "" : "Select a Location Type";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      addCorrection(values, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="remark"
            label="Remark"
            value={values.remark || ""}
            onChange={handleInputChange}
            error={errors.remark}
          />
          <Controls.Input
            label="Quantity"
            name="quantity"
            value={values.quantity || ""}
            onChange={handleInputChange}
            error={errors.quantity}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Select
            name="locationId"
            label="Select Storage (Location)"
            value={values.locationId || ""}
            onChange={handleInputChange}
            options={locations}
            error={errors.locationId}
          />
          <div style={{ position: "relative" }}>
            <Controls.Input
              label="SKU"
              name="sku"
              value={values.sku || ""}
              onChange={handleInputChange}
              error={errors.sku}
            />{" "}
            <i
              style={{ position: "relative", top: "0.8rem", right: "4rem" }}
              className="fas fa-barcode fa-3x"
            ></i>
          </div>
          <div>
            <Controls.Button type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
